import { render } from "./LinkPreviewToggle.vue?vue&type=template&id=7bc08faf&ts=true"
import script from "./LinkPreviewToggle.vue?vue&type=script&lang=ts"
export * from "./LinkPreviewToggle.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Users\\orson\\coding\\thelounge\\thelounge\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/LinkPreviewToggle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7bc08faf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7bc08faf', __exports__)) {
    api.reload('7bc08faf', __exports__)
  }
  
  module.hot.accept("./LinkPreviewToggle.vue?vue&type=template&id=7bc08faf&ts=true", () => {
    api.rerender('7bc08faf', render)
  })

}


export default __exports__